<template>

	<div class="panel panel-clinic">

		<div class="panel-heading collapsed" href="#form_supplementary_internal" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Tilläggsinformation mottagningsmassör</h2>

		</div>

		<div id="form_supplementary_internal" class="panel-collapse collapse">

			<div class="panel-body">

				<div class="form-horizontal">
                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :extra-data="{
                            'Inget val': 1,
                            'Egen lokal': 'Egen lokal',
                            'Hemmammottagning': 'Hemmammottagning',
                            'Inhyrd': 'In hyrd',
                         }"
                        :showComment="true"
                        type="select_premises_internal"
                        layout="selectMenu"
                        title="Typ av lokal">
                    </row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_experience_internal"
						layout="textBox"
						title="Erfarenhet/upparbetning mottagning"
						comment="Hur länge har du haft egen mottagning / haft igång den här mottagningen?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_clinic_description_internal"
						layout="textBox"
						title="Beskrivning av mottagning"
						comment="Be massören beskriva sin mottagning, t ex vad gäller läge, vilka andra som finns i samma lokal, är det hemma-hos etc.">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_days_available_internal"
						layout="textBox"
						title="Öppet / bokningsbar, antal dagar"
						comment="Hur många dagar i veckan har du öppet?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_hours_available_internal"
						layout="textBox"
						title="Öppet / bokningsbar, tider"
						comment="Vilka tider har du öppet? Erbjuder du kvällstider? Erbjuder du helgtider?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_capacity_internal"
						layout="textBox"
						title="Utrymme nya kunder"
						comment="Har du utrymme för fler kunder?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
						:showComment="true"
						type="select_insurance_internal"
						layout="selectMenu"
						title="Försäkring"
						comment="Har du en gällande patient- och ansvarsförsäkring?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
						:showComment="true"
						type="text_ftax_internal"
						layout="selectMenu"
						title="F-skatt / AB"
						comment="Har du registrerad f-skatt / AB?">
					</row-meta>

				</div>

				<p class="comment">
					Egen prissättning? Fråga vad massören själv tar för 25 resp 40 min, om du inte hittat uppgiften tidigare.
				</p>
				<div class="form-horizontal">

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showComment="true"
						type="text_list_price_25_min_internal"
						layout="textInput"
						title="Massörens eget listpris 25 min (eller närmsta beh längd)">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showComment="true"
						type="text_list_price_40_min_internal"
						layout="textInput"
						title="Massörens eget listpris 40 min (eller närmsta beh längd)">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showComment="true"
						type="text_list_price_60_min_internal"
						layout="textInput"
						title="Massörens eget listpris 50 min (eller närmsta beh längd)">
					</row-meta>

				</div>

				<div class="form-horizontal">
					<div class="form-group oddevencol">
						<b>OM du ej har mottagningsadress, hemsida, eller Facebook, är det bra om du ber om det nu.<br>
						Det är tillräckligt med information om antingen hemsida ELLER Facebook.</b>
					</div>
					<row-text :model.sync="clinic.address_prospect" text="Mottagningsadress – prospectfas" :asterisk="false"></row-text>
					<row-text :model.sync="clinic.website_link" text="Hemsida" :asterisk="false"></row-text>
					<row-text :model.sync="clinic.facebook_link" text="Länk Facebook" :asterisk="false"></row-text>
				</div>

				<div class="form-horizontal">
					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="textarea_supplementary_internal_extra_info"
							layout="textBox"
							title="Extra anteckningsruta, tilläggsfrågor mottagningsmassör"
							comment="Något annat du vill anteckna?">
					</row-meta>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

import mixin from './mixin'

export default {

    	mixins: [mixin],

	    data () {
      		return {

      		}
	    }

}

</script>
